import React from "react";
import ReactDOM from "react-dom";
import Router from "./Router/Router";
import "./normalize.css";
import "./style.css";

ReactDOM.render(<Router />, document.querySelector("body"));
